import axios from 'axios';
import {
  RAFFLE_AVAILABLE_TABS_REQUEST,
  RAFFLE_AVAILABLE_TABS_SUCCESS,
  RAFFLE_AVAILABLE_TABS_FAILURE,
  RAFFLE_PAGE_DATA_REQUEST,
  RAFFLE_PAGE_DATA_SUCCESS,
  RAFFLE_PAGE_DATA_FAILURE,
  RAFFLE_PRIZE_DATA_REQUEST,
  RAFFLE_PRIZE_DATA_SUCCESS,
  RAFFLE_PRIZE_DATA_FAILURE,
  RAFFLE_SERIAL_DATA_REQUEST,
  RAFFLE_SERIAL_DATA_SUCCESS,
  RAFFLE_SERIAL_DATA_FAILURE,
  RAFFLE_ONE_OF_SERIAL_REQUEST,
  RAFFLE_ONE_OF_SERIAL_SUCCESS,
  RAFFLE_ONE_OF_SERIAL_FAILURE,
  RAFFLE_BUY_TICKETS_REQUEST,
  RAFFLE_BUY_TICKETS_SUCCESS,
  RAFFLE_BUY_TICKETS_FAILURE,
  RAFFLE_BUY_TICKETS_RESET,
  TOGGLE_TICKET_TO_RAFFLE_SLIP,
  CLEAR_RAFFLE_SLIP,
  SET_RAFFLE_RENDERER,
  SET_RAFFLESLIP_FROM_LOCAL_STORAGE
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import { loadStateFromIndexedDB } from 'Utils/manageIndexedDB';
import { updateUserBalance } from 'Store/actions';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getRaffleAvailableTabs = () => async dispatch => {
  try {
    dispatch({
      type: RAFFLE_AVAILABLE_TABS_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/mobile/raffle/tabs`,
      method: 'get'
    });

    dispatch({
      type: RAFFLE_AVAILABLE_TABS_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: RAFFLE_AVAILABLE_TABS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getRafflePageData = (tabType, selectedTickets = []) => async dispatch => {
  try {
    dispatch({
      type: RAFFLE_PAGE_DATA_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/mobile/raffle/ticket-page?tabType=${tabType}`,
      method: 'get'
    });

    dispatch({
      type: RAFFLE_PAGE_DATA_SUCCESS,
      payload: {
        ...res.data,
        selectedTickets,
        tabType
      }
    });

  } catch (e) {

    dispatch({
      type: RAFFLE_PAGE_DATA_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getRaffleSerialData = (ticketType, tabType, serialType, selectedTickets) => async dispatch => {
  try {
    dispatch({
      type: RAFFLE_SERIAL_DATA_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/mobile/raffle/serial-ticket?serialType=${serialType}`,
      method: 'get'
    });

    dispatch({
      type: RAFFLE_SERIAL_DATA_SUCCESS,
      payload: {
        ...res.data,
        ticketType,
        tabType,
        serialType,
        selectedTickets
      }
    });

  } catch (e) {

    dispatch({
      type: RAFFLE_SERIAL_DATA_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getRaffleOneOfSerial = (serialInfo, serialType) => async dispatch => {
  try {
    dispatch({
      type: RAFFLE_ONE_OF_SERIAL_REQUEST
    });

    const { serialCode, drawNumber, ticketType } = serialInfo;

    const res = await axios({
      url: `${API_GATEWAY}/mobile/raffle/serial-ticket/${serialCode}?drawNumber=${drawNumber}&serialType=${serialType}&ticketType=${ticketType}`,
      method: 'get'
    });

    dispatch({
      type: RAFFLE_ONE_OF_SERIAL_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: RAFFLE_ONE_OF_SERIAL_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const toggleTicketToRaffleSlip = ticketData => dispatch => {
  dispatch({
    type: TOGGLE_TICKET_TO_RAFFLE_SLIP,
    payload: {
      ...ticketData
    }
  });
};

export const clearRaffleSlip = () => ({
  type: CLEAR_RAFFLE_SLIP
});

export const buyRaffleTickets = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: RAFFLE_BUY_TICKETS_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/mobile/raffle/ticket/purchase`,
      method: 'post',
      data: getState().raffle.raffleSlipData.buy
    });

    dispatch({
      type: RAFFLE_BUY_TICKETS_SUCCESS,
      payload: {
        ...res.data
      }
    });

    dispatch(updateUserBalance());
  } catch (e) {

    dispatch({
      type: RAFFLE_BUY_TICKETS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const buyTicketsResetRaffle = () => ({
  type: RAFFLE_BUY_TICKETS_RESET
});

export const getRafflePrizes = () => async dispatch => {
  try {
    dispatch({
      type: RAFFLE_PRIZE_DATA_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/mobile/raffle/prize`,
      method: 'get'
    });

    dispatch({
      type: RAFFLE_PRIZE_DATA_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: RAFFLE_PRIZE_DATA_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const setRaffleslipFromLocalStorage = () => dispatch => {
  loadStateFromIndexedDB('raffleSlip', data => {
    dispatch({
      type: SET_RAFFLESLIP_FROM_LOCAL_STORAGE,
      payload: data
    });
  });
};

export const setRaffleRenderer = () => dispatch => {
  dispatch({
    type: SET_RAFFLE_RENDERER
  });
};
